import { render, staticRenderFns } from "./BotaoEscolherDica.vue?vue&type=template&id=5c8e4f9c&scoped=true&"
import script from "./BotaoEscolherDica.vue?vue&type=script&lang=js&"
export * from "./BotaoEscolherDica.vue?vue&type=script&lang=js&"
import style0 from "./BotaoEscolherDica.vue?vue&type=style&index=0&id=5c8e4f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e4f9c",
  null
  
)

export default component.exports